import React from 'react';

import PropTypes from 'prop-types';

const VideoPlayIcon = ({ width = 29, height = 32, color = 'white' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 29 32"
      fill="none"
    >
      <g filter="url(#filter0_d_19689_91207)">
        <path
          d="M22.5 14.7505C22.5006 15.0051 22.4353 15.2556 22.3105 15.4775C22.1856 15.6995 22.0055 15.8853 21.7875 16.017L8.28 24.2802C8.05227 24.4196 7.79144 24.4957 7.52445 24.5007C7.25746 24.5056 6.99399 24.4392 6.76125 24.3083C6.53073 24.1794 6.3387 23.9914 6.2049 23.7637C6.07111 23.536 6.00039 23.2768 6 23.0127V6.48828C6.00039 6.22417 6.07111 5.96493 6.2049 5.73722C6.3387 5.50951 6.53073 5.32155 6.76125 5.19266C6.99399 5.06173 7.25746 4.99531 7.52445 5.00026C7.79144 5.0052 8.05227 5.08133 8.28 5.22078L21.7875 13.4839C22.0055 13.6156 22.1856 13.8015 22.3105 14.0234C22.4353 14.2453 22.5006 14.4958 22.5 14.7505Z"
          fill={color}
          fillOpacity="0.9"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_19689_91207"
          x="-10"
          y="-7.25"
          width="44"
          height="44"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="3" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_19689_91207"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_19689_91207"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

VideoPlayIcon.propTypes = {
  color: PropTypes.string,
  height: PropTypes.number,
  width: PropTypes.number,
};

export default VideoPlayIcon;
